<div class="component-main-container">
  <app-page-header parentTitle="{{ 'logs.logs-parent-label' | translate }}"
    pageTitle="{{ 'logs.form-filter-user' | translate }}">
  </app-page-header>

  <!--Corpo do componente-->
  <div class="row">
    <div class="col-lg-5 col-xl-4 col-sm-12">
      <div class="component-forms-box">
        <app-logs-form></app-logs-form>

        <div class="form-fields-box" [ngClass]="!filterBox ? 'closed' : ''" [formGroup]="filterLogsForm">
          <h2 (click)="filterBoxOpen()">
            {{ "logs.form-filter-label" | translate }}
          </h2>
          <hr [ngClass]="!filterBox ? 'hr-open' : ''" />

          <div class="form-step">
            <mat-form-field appearance="outline" class="example-form-field">
              <mat-label>{{ "logs.form-operation" | translate }}</mat-label>

              <mat-select formControlName="operation" name="operation">
                <mat-option value="">{{ "logs.form-filter-null" | translate}}</mat-option>
                <mat-option value="CREATE">{{"logs.form-create-label" | translate}}</mat-option>
                <mat-option value="UPDATE">{{"logs.form-update-label" | translate}}</mat-option>
              </mat-select>
            </mat-form-field>
          </div>

          <div class="form-step">
            <div class="date-picker-input">
              <p-datepicker inputId="calendar-24h" selectionMode="range" formControlName="logsDateTime" appendTo="body"
                placeholder="{{ 'logs.form-date' | translate }}" showIcon iconDisplay="input" dateFormat="dd/mm/yy">
              </p-datepicker>
            </div>
          </div>

          <div class="form-step">
            <mat-form-field appearance="outline">
              <mat-label>{{"logs.form-main-user-log" | translate}}</mat-label>
              <input matInput formControlName="userUsername" />
            </mat-form-field>
          </div>

          <div class="form-step">
            <mat-form-field appearance="outline">
              <mat-label>{{"logs.form-changed-user-log" | translate}}</mat-label>
              <input matInput formControlName="targetUsername" />
            </mat-form-field>
          </div>

          @if (!filterLoading) {
          <button title="{{ 'logs.form-filter-button' | translate }}" class="btn btn-success"
            (click)="filterUserLogs(null)">
            {{ "logs.form-filter-button" | translate }}
          </button>
          }
          @if (filterLoading) {
          <mat-spinner [diameter]="30"></mat-spinner>
          }
        </div>
      </div>
    </div>

    <!-- Sessão tabela -->
    @if (paginationProperties.total) {
    <div class="col-lg-7 col-xl-8 col-sm-12">
      <app-table-header [itensNumber]="paginationProperties.count" [totalNumber]="paginationProperties.total"
        [hasCSV]="true" [hasPDF]="true" (downloadCSV)="generateFileData(null, 'CSV')"
        (downloadPDF)="generateFileData(null, 'PDF')" [loadingData$]="fileLoading"></app-table-header>
      @if (filterLoading) {
      <mat-spinner class="mt-3" [diameter]="30"></mat-spinner>
      }
      <div class="table-container mt-2 mt-lg-3 mt-xl-3">
        <p-table [value]="ELEMENT_DATA" [rows]="pageSize" [totalRecords]="length" dataKey="id" [paginator]="true"
          (onPage)="pageChanged($event)" [showPageLinks]="false" [showFirstLastIcon]="false" [lazy]="true">
          <ng-template pTemplate="header">
            <tr>
              <th pSortableColumn="username" style="width:20%;"> {{ "logs.form-filter-user" | translate }}</th>
              <th pSortableColumn="operationType" style="width:20%;">{{ "logs.form-operation" | translate }}</th>
              <th pSortableColumn="targetUser" style="width:20%;">{{"logs.form-changed-user-log" | translate}}</th>
              <th pSortableColumn="dateTime" style="width:22%;"> {{"logs.form-logDatetime" | translate}}</th>
              <th pSortableColumn="payload" style="width:18%;"> {{"logs.form-updates-log" | translate}}</th>
            </tr>
          </ng-template>
          <ng-template pTemplate="body" let-row let-columns="columns" let-ri="rowIndex">
            <tr>
              <td>{{row.username}}</td>
              <td>{{row.operationType}}</td>
              <td>{{row.targetUser}}</td>
              <td>{{formatDate(row.dateTime)}}</td>
              <td>
                <mat-accordion>
                  <mat-expansion-panel>
                    <mat-expansion-panel-header>
                      <mat-panel-description>{{"logs.form-view-updates" | translate}}</mat-panel-description>
                    </mat-expansion-panel-header>
                    <br>
                    @if (row.details.companiesAdd) {
                    <div>
                      {{"logs.table-info-companies-add" | translate}}:
                      <p style="color: green;">{{row.details.companiesAdd}}</p>
                    </div>
                    }
                    @if (row.details.companiesRemove) {
                    <div>
                      {{"logs.table-info-companies-removed" | translate}}:
                      <p style="color: red;">{{row.details.companiesRemove}}
                      </p>
                    </div>
                    }
                    @if (row.details.permissionsAdd?.length) {
                    <div>
                      {{"logs.table-info-permissions-add" | translate}}:
                      <p style="color: green;">{{row.details.permissionsAdd?.length}}</p>
                    </div>
                    }
                    @if (row.details.permissionsRemove?.length) {
                    <div>
                      {{"logs.table-info-permissions-removed" | translate}}:
                      <p style="color: red;">{{row.details.permissionsRemove?.length}}
                      </p>
                    </div>
                    }
                    @if (row.details.groupsAdd?.length) {
                    <div>
                      {{"logs.table-info-groups-add" | translate}}:
                      <p style="color: green;">{{row.details.groupsAdd?.length}}</p>
                    </div>
                    }
                    @if (row.details.groupsRemove?.length) {
                    <div>
                      {{"logs.table-info-groups-removed" | translate}}:
                      <p style="color: red;">{{row.details.groupsRemove?.length}}</p>
                    </div>
                    }
                    @if (row.details.changeIsActive) {
                    <div>
                      {{"logs.table-changed-is-active" | translate}}
                    </div>
                    }
                    @if (row.details.changedIsSuperuser) {
                    <div>
                      {{"logs.table-changed-is-superuser" | translate}}
                    </div>
                    }
                    @if (row.details.changedPassword) {
                    <div>
                      {{"logs.table-changed-password" | translate}}
                    </div>
                    }
                    @if (!row.details.hasChanges) {
                    <div>{{"logs.table-no-changes-made" | translate}}</div>
                    }
                    @if (row.details.hasMoreInfo) {

                    <p-button (click)="openDialog(row)" icon="pi pi-eye" styleClass="btn-actions" [rounded]="true" />
                    }
                  </mat-expansion-panel>
                </mat-accordion>
              </td>
          </ng-template>
        </p-table>
      </div>
    </div>
    }
  </div>

  <!-- Dialog com detalhes das mudanças realizadas no usuário -->
  <ng-template #dialogTemplate let-dialogRef="dialogRef">
    <mat-dialog-content class="mat-typography">
      <div class="dialogRef" style="text-align: center;">
        <h1 mat-dialog-title>{{"logs.title-info-operations" | translate}}</h1>
        <hr>
        @if (choosenElement.details.permissionsAdd?.length) {
        <div class="d-flex align-items-start flex-column text-center" style="font-size: 19px;">
          <div class="p-2">
            <h1 mat-dialog-title>{{"logs.table-info-permissions-add" | translate}}</h1>
            <mat-card appearance="outlined">
              <mat-card-content>@for (item of choosenElement.details.permissionsAdd; track item) {
                <strong>{{item}}<br>
                </strong>
                }</mat-card-content>
            </mat-card>
            @if (choosenElement.details.permissionsRemove?.length) {
            <div class="dialog-hr" style="margin-top: 30px; margin-bottom: 30px;">
              <hr>
            </div>
            }
          </div>
        </div>
        }
        @if (choosenElement.details.permissionsRemove?.length) {
        <div class="d-flex align-items-start flex-column text-center" style="font-size: 19px;">
          <div class="p-2">
            <h1 mat-dialog-title>{{"logs.table-info-permissions-removed" | translate}}</h1>
            <mat-card appearance="outlined">
              <mat-card-content>@for (item of choosenElement.details.permissionsRemove; track item) {
                <strong>{{item}}<br>
                </strong>
                }</mat-card-content>
            </mat-card>
            <div class="dialog-hr">
              <hr>
            </div>
          </div>
        </div>
        }

        @if (choosenElement.details.groupsAdd?.length) {
        <div class="d-flex align-items-start flex-column text-center" style="font-size: 19px;">
          <div class="p-2">
            <h1 mat-dialog-title>{{"logs.table-info-groups-add" | translate}}</h1>
            <mat-card appearance="outlined">
              <mat-card-content>@for (item of choosenElement.details.groupsAdd; track item) {
                <strong>{{item}}<br>
                </strong>
                }</mat-card-content>
            </mat-card>
            @if (choosenElement.details.groupsRemove?.length) {
            <div class="dialog-hr" style="margin-top: 30px; margin-bottom: 30px;">
              <hr>
            </div>
            }
          </div>
        </div>
        }

        @if (choosenElement.details.groupsRemove?.length) {
        <div class="d-flex align-items-start flex-column text-center" style="font-size: 19px;">
          <div class="p-2">
            <h1 mat-dialog-title>{{"logs.table-info-groups-removed" | translate}}</h1>
            <mat-card appearance="outlined">
              <mat-card-content>@for (item of choosenElement.details.groupsRemove; track item) {
                <strong>{{item}}<br>
                </strong>
                }</mat-card-content>
            </mat-card>
            <div class="dialog-hr">
              <hr>
            </div>
          </div>
        </div>
        }
      </div>
    </mat-dialog-content>
  </ng-template>
</div>